{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-8-bwr-erfolgskonten-guv-werkstoffe-rabatte",
  "version": "2026.08.1",
  "title": "BwR 8: Erfolgskonten (Aufwand/Ertrag), GuV-Konto, Werkstoffeinkauf und Skonti (Realschule 8 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern BwR 8 (Wahlpflichtfächergruppe II): Erfolgskonten (Aufwendungen mindern EK / Soll; Erträge mehren EK / Haben), Gewinn- und Verlustrechnung (GuV), Werkstoffeinkauf, Bezugskosten und Skontoberechnung.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T23:15:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/8/bwr",
      "checked": "2026-08-15",
      "label": "Realschule BwR 8 (Wahlpflichtfächergruppe II), Lernbereiche Erfolgsvorgänge und Beschaffung"
    }
  ],
  "atoms": [
    {
      "id": "01K4W8E0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4W8E0000000000000000A01",
      "namespace": "bwr-erfolgsvorgaenge",
      "slug": "erfolgskonten-aufwand-ertrag-guv-abschluss-eigenkapital",
      "title": "Erfolgskonten und GuV: Aufwendungen (Soll) vs. Erträge (Haben), GuV-Konto und Eigenkapitalveränderung",
      "domain": "schule/bwr/erfolg",
      "reduction": "formal",
      "typical_age_min": 13.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q8134",
          "target_label": "Income statement",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 8,
          "track": "II",
          "subject": "bwr",
          "topic_code": "lb1",
          "topic_title": "Erfolgswirksame Geschäftsfälle und GuV",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4W8E0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Auf welcher Kontoseite werden Aufwendungen (z. B. Löhne, Miete, Zinsaufwand) auf den entsprechenden Aufwandskonten verbucht?",
          "concept": "Auf der Soll-Seite (Aufwand = Werteverzehr = Sollbuchung)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Auf der Soll-Seite (links)",
              "Auf der Haben-Seite (rechts)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4W8E0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre das System der Erfolgskonten als Unterkonten des Eigenkapitals: 1. **Aufwandskonten** (betrieblicher Werteverzehr/Kosten: Löhne, Gehälter, Büromaterial, Werbung, Mietaufwand $\\rightarrow$ mindern das Eigenkapital $\\rightarrow$ Buchungen immer im **Soll**), 2. **Ertragskonten** (betrieblicher Wertezuwachs: Umsatzerlöse für eigene Erzeugnisse, Provisionserträge, Zinserträge $\\rightarrow$ mehren das Eigenkapital $\\rightarrow$ Buchungen immer im **Haben**), 3. Das **Gewinn- und Verlustkonto (GuV)** als Sammelkonto (Soll: alle Aufwendungen; Haben: alle Erträge), 4. **Erfolgsermittlung und Abschluss über das Eigenkapitalkonto**: Saldo Haben > Soll = **Jahresüberschuss / Reingewinn** (*Buchung: GuV an EK*); Saldo Soll > Haben = **Jahresfehlbetrag / Reinverlust** (*Buchung: EK an GuV*).",
          "concept": "Erfolgskonten: Aufwand im Soll (mindert EK); Ertrag im Haben (mehrt EK); GuV sammelt Aufwendungen im Soll und Erträge im Haben; Reingewinn steht im Soll des GuV und mehrt das EK (GuV an EK); Reinverlust steht im Haben des GuV und mindert das EK (EK an GuV).",
          "sample_solution": "1. Wesen der Erfolgskonten (Erfolgswirksame Geschäftsfälle): - Während reine Bestandsbuchungen (Aktiv-/Passivtausch) das Eigenkapital unverändert lassen, verändern **Erfolgsvorgänge das Reinvermögen (Eigenkapital)** des Unternehmens. - Um das Eigenkapitalkonto übersichtlich zu halten, wird es in **zwei Arten von Unterkonten (Erfolgskonten)** aufgelöst:   * **1. Aufwandskonten (Werteverzehr)**:     - Erfassen Güter- und Dienstleistungsverbrauch zur betrieblichen Leistungserstellung (z. B. `6000 AWR` Aufwendungen für Rohstoffe, `6200 L` Löhne, `6300 G` Gehälter, `6700 M` Mietaufwendungen, `6800 BM` Büromaterial, `6870 WE` Werbeaufwand).     - Da Aufwendungen das Eigenkapital **mindern**, werden sie immer im **Soll** gebucht.     - Haben **keinen Anfangsbestand** zu Jahresbeginn.   * **2. Ertragskonten (Wertezuwachs)**:     - Erfassen den Wertezufluss durch Verkauf und Dienstleistungen (z. B. `5000 UEFE` Umsatzerlöse für Fertigerzeugnisse, `5400 EMP` Erlöse aus Vermietung, `5430 ZIE` Zinserträge).     - Da Erträge das Eigenkapital **mehren**, werden sie immer im **Haben** gebucht.     - Haben ebenfalls **keinen Anfangsbestand**. 2. Das Gewinn- und Verlustkonto (GuV) und Jahresabschluss: - Zum Jahresende (31. Dezember) werden alle Erfolgskonten über das zentrale Sammelkonto **GuV** abgeschlossen:   * *Abschluss Aufwandskonten*: **`GuV an Aufwandskonto`**   * *Abschluss Ertragskonten*: **`Ertragskonto an GuV`** - **Erfolgsbilanzierung**:   * **Gewinnfall (Erträge > Aufwendungen)**:     - Die Habenseite des GuV ist größer als die Sollseite. Der Saldo (**Reingewinn**) steht auf der Sollseite des GuV.     - **Abschlussbuchung auf das Eigenkapitalkonto**: **`GuV an EK [Gewinnbetrag]`** (mehrt das Eigenkapital!).   * **Verlustfall (Aufwendungen > Erträge)**:     - Die Sollseite des GuV ist größer als die Habenseite. Der Saldo (**Reinverlust**) steht auf der Habenseite des GuV.     - **Abschlussbuchung**: **`EK an GuV [Verlustbetrag]`** (mindert das Eigenkapital!)."
        }
      ]
    },
    {
      "id": "01K4W8E0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4W8E0000000000000000A02",
      "namespace": "bwr-beschaffung",
      "slug": "werkstoffeinkauf-bezugskosten-liefererrabatt-skonto",
      "title": "Werkstoffbeschaffung: Rohstoffe (AWR), Bezugskosten (BZKR), Liefererrabatt und Liefererskonto",
      "domain": "schule/bwr/beschaffung",
      "reduction": "formal",
      "typical_age_min": 13.5,
      "prerequisites": [
        {
          "atom_id": "01K4W8E0000000000000000A01",
          "type": "hard",
          "rationale": "Werkstoffeinkäufe werden auf Erfolgskonten (Aufwand für Rohstoffe) verbucht."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q8134",
          "target_label": "Procurement accounting",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 8,
          "track": "II",
          "subject": "bwr",
          "topic_code": "lb2",
          "topic_title": "Beschaffung und Werkstoffe",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4W8E0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie wird ein sofort beim Einkauf gewährter Liefererrabatt (z. B. 10 % Mengenrabatt auf der Eingangsrechnung) buchhalterisch behandelt?",
          "concept": "Er wird direkt vom Listenpreis abgezogen; eingebucht wird nur der gekürzte Rechnungsbetrag (Rabatte erhalten kein eigenes Buchungskonto)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Direkter Abzug, kein eigenes Buchungskonto",
              "Buchung auf ein Rabattertragskonto"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4W8E0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre die buchhalterische Erfassung des Werkstoffeinkaufs: 1. Werkstoffarten (Rohstoffe `AWR` = Hauptbestandteil des Produkts, Fremdbauteile `AWF` = zugekaufte Fertigteile, Hilfsstoffe `AWH` = untergeordnete Stoffe wie Leim/Lack, Betriebsstoffe `AWB` = Verbrauch für Maschinen wie Schmieröl/Strom), 2. **Bezugskosten `BZKR`** (Fracht, Verpackung, Transportversicherung, Zölle; werden als Anschaffungsnebenkosten gesondert im Soll erfasst), 3. Unterscheidung von **Liefererrabatt** (sofortiger Rechnungsabzug) und **Liefererskonto** (nachträglicher Preisnachlass bei schneller Zahlung innerhalb der Skontofrist, z. B. 2 % bei Zahlung binnen 10 Tagen) und bilde die Buchungssätze für: a) Kauf von Rohstoffen 20.000 € und Fremdbauteilen 10.000 € auf Ziel (Rechnung), b) Wir überweisen per Bank Frachtkosten für den Rohstoffeinkauf in Höhe von 600 €.",
          "concept": "Werkstoffeinkauf: AWR/AWF/AWH/AWB; Bezugskosten BZKR im Soll; Rabatt sofort abgezogen; Skonto nachträglich bei Zahlung; a) 'AWR 20.000 € und AWF 10.000 € an VLL 30.000 €'; b) 'BZKR 600 € an BK 600 €'.",
          "sample_solution": "1. Systematik der Werkstoffe im Industriebetrieb: - **1. Rohstoffe (`6000 AWR`)**: Hauptbestandteil des fertigen Erzeugnisses (z. B. Holz bei Tischen, Stahl bei Maschinen). - **2. Fremdbauteile (`6010 AWF`)**: Zugekaufte montagefertige Komponenten (z. B. Fahrradsättel, Computerchips, Reifen). - **3. Hilfsstoffe (`6020 AWH`)**: Gehen in das Produkt ein, bilden aber nur Nebenbestandteile (z. B. Schrauben, Leim, Nähgarn, Farbe). - **4. Betriebsstoffe (`6030 AWB`)**: Gehen nicht in das Produkt ein, sondern werden beim Betrieb der Maschinen verbraucht (z. B. Strom, Erdgas, Schmieröle, Benzin). 2. Bezugskosten und Preisnachlässe: - **Bezugskosten (`6001 BZKR / BZKF`)**:   * Alle Nebenkosten des Transports vom Lieferanten zu unserem Betrieb (Fracht, Spedition, Rollgeld, Transportversicherung, Leihverpackung, Zölle).   * Werden auf dem gesonderten Unterkonto `BZKR` im **Soll** gebucht und erhöhen den Werkstoffaufwand. - **Liefererrabatt**:   * Wird sofort auf der Rechnung vom Listenpreis abgezogen (*Nettopreis*). Es erfolgt **keine gesonderte Buchung**. - **Liefererskonto**:   * Ein vom Lieferanten gewährter Zins- und Liquiditätsvorteil bei schneller Bezahlung innerhalb der vereinbarten Skontofrist (z. B. *'Zahlung innerhalb von 10 Tagen abzüglich 2 % Skonto'*).   * Wird erst im Zeitpunkt des Bankausgleichs buchhalterisch erfasst. 3. Buchungssätze der Übungsfälle: - **a) Kauf von Rohstoffen 20.000 € und Fremdbauteilen 10.000 € auf Ziel**:   * Zusammengesetzter Buchungssatz:   $$\\mathbf{\\text{6000 AWR } 20.000\\text{ € } \\quad \\& \\quad \\text{6010 AWF } 10.000\\text{ € } \\quad \\text{an} \\quad \\text{4400 VLL } 30.000\\text{ €}}$$ - **b) Banküberweisung von Transport-/Frachtkosten für Rohstoffe 600 €**:   * Einfacher Buchungssatz:   $$\\mathbf{\\text{6001 BZKR } 600\\text{ € } \\quad \\text{an} \\quad \\text{2800 BK } 600\\text{ €}}$$"
        }
      ]
    }
  ]
}
